module.exports = __webpack_public_path__ + "static/media/ht.9012459f.svg";